import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import auditLogEsCL from './locales/es-CL.json';
import auditLogEnUS from './locales/en-US.json';
import auditLogPtBR from './locales/pt-BR.json';

export const auditLogI18n = buildScopedI18n({
  esCL: auditLogEsCL,
  enUS: auditLogEnUS,
  ptBR: auditLogPtBR,
});